import { render, staticRenderFns } from "./ReportIndividualTable.vue?vue&type=template&id=80f6ccce&scoped=true&"
import script from "./ReportIndividualTable.vue?vue&type=script&lang=ts&"
export * from "./ReportIndividualTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportIndividualTable.vue?vue&type=style&index=0&id=80f6ccce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f6ccce",
  null
  
)

export default component.exports